import { Route } from '@angular/router';
import { UiWebHomeComponent } from '@drct-web-apps/ui-web-home';


export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: UiWebHomeComponent,
    children: [
      { 
        path: '', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-central').then((m) => m.webCentral)
      },
      { 
        path: 'history', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-history').then((m) => m.webHistory)
      },
      { 
        path: 'priests', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-priests').then((m) => m.webPriests)
      },
      { 
        path: 'schedule', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-schedule').then((m) => m.webSchedule)
      },
      { 
        path: 'events', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-events').then((m) => m.webEvents)
      },
      { 
        path: 'register', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-register').then((m) => m.webRegister)
      },
      { 
        path: 'receipt', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-confirm').then((m) => m.webConfirm)
      },
      { 
        path: 'ministries', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-ministries').then((m) => m.webMinistries)
      },
      { 
        path: 'testimonies', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-testimonies').then((m) => m.webTestimonies)
      },
      { 
        path: 'photo-gallery', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-photo-gallery').then((m) => m.webPhotoGallery)
      },
      { 
        path: 'photo-gallery-view', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-photo-gallery-view').then((m) => m.webPhotoGalleryView)
      },
      { 
        path: 'donation', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-donation').then((m) => m.webDonation)
      },
      { 
        path: 'mass-offer', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-mass-offer').then((m) => m.webMassOffer)
      },
      { 
        path: 'prayer-request', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-form').then((m) => m.webForm),
        data: { formType: 'prayer-request' }
      },
      { 
        path: 'send-testimonies', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-form').then((m) => m.webForm),
        data: { formType: 'send-testimonies' }
      },
      { 
        path: 'contact-us', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-contact-us').then((m) => m.webContactUs)
      },
      { 
        path: 'brochure', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-brochure').then((m) => m.webBrochure)
      },
      { 
        path: 'video-gallery', pathMatch: 'full',
        loadChildren: () => import('@drct-web-apps/ui-web-play-list').then((m) => m.webPlayList)
      }
    ]
  }
];
